import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { commissionQueries } from '@/services/commissions/commissions.queries';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';

export const useCommissionStatusToggle = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const mutation = useMutation('toggleStatusCommission', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: [...commissionQueries.all()] });
      toast.success(res.message);
      void navigate({ to: '/configuration-management/commissions' });
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });

  return { mutateAsync: mutation.mutateAsync };
};
